import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ChannelBreakdown from '../../common/components/charts/ChannelBreakdown';
import { useSelector, useDispatch } from 'react-redux';
import { getChannelBreakdownSales } from '../../redux/actions/salesActions';
import { getDimention } from '../../helper/utils';
import { UserPortalContext } from '../../context/appcontext';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@mui/material';
import { colors } from '../../theme/color-palette';

const useStyles = makeStyles(() => ({
	container: {
		width: (P) => P.chartWidth,
		border: `1px solid ${colors.LIGHT_GREY}`,
		borderRadius: '8px',
		height: '430px',
	},
}));

function ChannelBreakdownWrapper(props) {
	const { weekFilter, selectedFilter, category, updatedWidth, tab } = props;
	const dispatch = useDispatch();

	const classes = useStyles();

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);
	const { startDate, endDate } = selectedFilters;

	const { cbSalesData, cbUnitsData, selectedUPC } = useSelector(
		(state) => state.salesReducer
	);

	const cbSalesLoading = useSelector(
		(state) => state.salesReducer.cbSalesLoading
	);
	const cbSalesErrorCode = useSelector(
		(state) => state.salesReducer.cbSalesErrorCode
	);

	const hierarchyFilterRhid = useSelector(
		(state) =>
			state?.fullCompanyViewReducer?.selectedHierarchy?.hierarchyFilterRhId
	);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	const isUPC = useSelector((state) => state.appGuideReducer.isUPC);

	const portalUserContext = React.useContext(UserPortalContext);

	const getPeriod = () => {
		if (weekFilter === -1) {
			return {
				startDate: startDate,
				endDate: endDate,
			};
		} else {
			return { period: weekFilter };
		}
	};

	useEffect(() => {
		const hierarchyData = {
			request: {
				duration: getPeriod(),
				channel: selectedFilter?.toUpperCase(),
				filter: {
					kpis: ['NET_SALES', 'SALES_VOLUME'],
					rhIds: hierarchyFilterRhid?.split(','),
				},
				additionalFilter: {
					dimension: getDimention(hierarchyFilterRhid),
				},
			},
			portalUserContext: portalUserContext,
		};

		const upcData = {
			request: {
				duration: getPeriod(),
				channel: selectedFilter?.toUpperCase(),
				filter: {
					kpis: ['NET_SALES', 'SALES_VOLUME'],
					[isUPC ? 'upcs' : 'items']: selectedUPC,
				},
				additionalFilter: {
					dimension: 'ITEM',
				},
			},
			portalUserContext: portalUserContext,
		};

		const getData = setTimeout(() => {
			if (selectedUPC && selectedUPC?.length > 0) {
				dispatch(getChannelBreakdownSales(upcData));
			} else if (hierarchyFilterRhid?.length > 0) {
				dispatch(getChannelBreakdownSales(hierarchyData));
			}
		}, 100);

		return () => clearTimeout(getData);
	}, [
		selectedFilter,
		weekFilter,
		startDate,
		endDate,
		hierarchyFilterRhid,
		selectedUPC,
		selectedView,
	]);

	const cbData = {
		cbSalesData: cbSalesData,
		cbUnitsData: cbUnitsData,
		isloading: [cbSalesLoading, cbSalesLoading],
		isError: [cbSalesErrorCode, cbSalesErrorCode],
		summary: cbSalesData?.summary,
	};

	return (
		<Box className={classes.container}>
			<ChannelBreakdown
				selectedFilter={selectedFilter}
				weekFilter={weekFilter}
				category={category}
				data={cbData}
				updatedWidth={updatedWidth}
				tab={tab}
			/>
		</Box>
	);
}

ChannelBreakdownWrapper.propTypes = {
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selectedFilter: PropTypes.string,
	category: PropTypes.string,
	updatedWidth: PropTypes.number,
	tab: PropTypes.string,
};

export default ChannelBreakdownWrapper;
